module.exports = __webpack_public_path__ + "static/img/14.1ae809f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/14.png
// module id = f8Kd
// module chunks = 0